import React, { useState, useEffect, useRef } from 'react';
import _ from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { verifyauthCheck, getVouchersList } from "../handlers/adminApi";
import { DotLoader } from 'react-spinners';
import axios from 'axios';

function Voucher() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddVoucherModal, setShowAddVoucherModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const vouchersPerPage = 5;

  const totalVouchers = vouchers.length;
  const totalPages = Math.ceil(totalVouchers / vouchersPerPage);
  const indexOfLastVoucher = currentPage * vouchersPerPage;
  const indexOfFirstVoucher = indexOfLastVoucher - vouchersPerPage;
  const currentVouchers = vouchers.slice(indexOfFirstVoucher, indexOfLastVoucher);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = (e) => {
    e.preventDefault();
    setShowDeleteModal(false);
    setDeleteIndex(null);
  };

  // Delete function
  const deleteVoucher = async (voucherId) => {
    try {
      // Sending the delete request to the backend to delete the voucher
      const response = await axios.delete(`${process.env.REACT_APP_API_HOSTNAME}/admin/vouchers/delete-voucher/${voucherId}`);
      console.log('Voucher deleted:', response.data);

      // If the backend confirms successful deletion (status true), we can proceed
      if (response.data.status === true) {
        return response.data;
      } else {
        throw new Error('Failed to delete voucher');
      }
    } catch (error) {
      console.error('Error deleting voucher:', error);
      throw error; // Re-throw for the caller to handle
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    const voucherToDelete = vouchers[deleteIndex]; // Get the voucher to delete based on the index
    console.log(`Deleting voucher with ID: ${voucherToDelete.stripe_coupon_id}`);

    try {
      // Call delete on the backend using voucher_id
      const deleteResponse = await deleteVoucher(voucherToDelete.stripe_coupon_id); // Call API to delete

      // If deletion is successful on the backend, update the frontend
      if (deleteResponse.status === true) {
        // Remove the deleted voucher from the local state (front-end state)
        const updatedVouchers = vouchers.filter(voucher => voucher.stripe_coupon_id !== voucherToDelete.stripe_coupon_id);
        setVouchers(updatedVouchers); // Update state with the new list

        window.location.reload();
        closeDeleteModal(e); // Close the delete modal

        console.log('Voucher deleted successfully');

      } else {
        console.error('Failed to delete the voucher');
      }
    } catch (error) {
      console.error('Error during deletion:', error);
    }
  }
  const openAddVoucherModal = (e) => {
    e.preventDefault();
    setShowAddVoucherModal(true);
  };

  const closeAddVoucherModal = (e) => {
    e.preventDefault();
    setShowAddVoucherModal(false);
  };

  const [formData, setFormData] = useState({
    voucherCode: '',
    discountPercentage: '',
  });

  // Handle input changes for the new keys
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  // Function to add the voucher using the new keys
  const addVoucher = async (voucherData) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_HOSTNAME}/admin/vouchers/add-voucher`, voucherData);
      console.log('Voucher added:', response.data);
      return response.data;
      window.location.reload();

    } catch (error) {
      console.error("Error adding voucher:", error);
    }
  };

  // Handle form submission for adding the voucher
  const handleAddVoucher = async (e) => {
    e.preventDefault();
    const { voucherCode, discountPercentage } = formData; // Use the new keys for the data
    try {
      const newVoucher = await addVoucher({
        voucherCode: voucherCode,              // Send voucherCode as key
        discountPercentage: parseInt(discountPercentage),  // Send discountPercentage as key
      });
      setVouchers([newVoucher, ...vouchers]); // Add the new voucher at the start of the list
      console.log("New voucher added:", newVoucher);
      window.location.reload();

      closeAddVoucherModal(); // Close modal after successful add
    } catch (error) {
      console.error("Error adding voucher:", error);
    }
  };

  const hasRun = useRef(false);
  const authCheck = async () => {
    var resp = await verifyauthCheck();
    if (resp != null) {
      if (resp.status === true) {
        navigate(location.pathname, {
          state: { ...location.state, userData: resp.userData }
        });
      } else {
        navigate("/");  // Redirect to login if not authenticated
      }
    }
  };

  const getVouchers = async () => {
    setLoading(true);
    try {
      const resp = await getVouchersList({ 'page': '1' });  // Fetch the updated vouchers
      const fetchedVouchers = _.get(resp, 'data', []);  // Get fresh data
  
      // Optional: If vouchers have a timestamp or ID, you can sort them
      const sortedVouchers = fetchedVouchers.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at); // Sort by date, newest first
      });
  
      // Set the state with sorted vouchers
      setVouchers(sortedVouchers);
    } catch (error) {
      console.error("Error fetching vouchers:", error);
    } finally {
      setLoading(false);  // Stop loader
    }
  };
  

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      authCheck();
      getVouchers();  // Fetch vouchers on first render
    }
  }, []);

  return (
    <div className="voucher-main">
      <div className="middle">
        <div className="right2">
          <div className="title">
            <h2>Voucher</h2>
          </div>
          {loading ? (
            <div className="loader" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginLeft: '450px', marginTop: '90px' }}>
              <DotLoader size={60} color="#F7812A" />
            </div>
          ) : (
            <div className="table">
              <div className="theme-btn">
                <div className="btn">
                  <a href="#!" onClick={openAddVoucherModal}>+ Add Voucher</a>
                </div>
              </div>

              <table>
                <tr>
                  <th>Voucher code</th>
                  <th>Discount</th>
                  <th>Action</th>
                </tr>

                {currentVouchers.map((voucher, index) => (
                  <tr key={voucher.stripe_coupon_id}>
                    <td>{voucher.voucher_code}</td>
                    <td>{voucher.discount}%</td>
                    <td>
                      <a href="#!" onClick={(e) => { e.preventDefault(); openDeleteModal(index); }}>
                        <FontAwesomeIcon icon={faTrash} style={{ color: 'red', marginLeft: 20 }} />
                      </a>
                    </td>
                  </tr>
                ))}
              </table>

              <hr className="horizontal-line" />
              <div className="pagination">
                <span>
                  Showing {Math.min(indexOfLastVoucher, totalVouchers)} of {totalVouchers} entries
                </span>
                <div className="pagination-buttons">
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={currentPage === index + 1 ? 'active' : ''}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="edit-form change-sub">
            <div className="form">
              <form>
                <h2>Delete</h2>
                <p>Are you sure you want to delete this voucher?</p>

                <div className="theme-btn log-out">
                  <div className="btn">
                    <a style={{ cursor: 'pointer' }} onClick={handleDelete}>Delete</a>
                  </div>

                  <div className="btn btn2">
                    <a style={{ cursor: 'pointer' }} onClick={closeDeleteModal}>Cancel</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showAddVoucherModal && (
        <div className="modal-overlay">
          <div className="edit-form">
            <div className="form">
              <form onSubmit={handleAddVoucher}>
                <h2>Add Voucher</h2>

                <div className="form-group">
                  <label htmlFor="voucherCode">Voucher Code</label>
                  <input
                    type="text"
                    id="voucherCode"
                    value={formData.voucherCode}
                    onChange={handleInputChange}
                    placeholder="Enter voucher code"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="discountPercentage">Discount Percentage</label>
                  <input
                    type="text"
                    id="discountPercentage"
                    value={formData.discountPercentage}
                    onChange={handleInputChange}
                    placeholder="Enter percentage"
                    required
                  />
                  <i>%</i>
                </div>

                <div className="theme-btn" style={{ marginTop: 50, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div className="btn" style={{ marginRight: '10px' }}>
                    <button
                      type="submit"
                      style={{
                        backgroundColor: '#F7812A',
                        color: 'white',
                        width: '160px',
                        height: '60px',
                        borderRadius: '50px',
                        border: 'none',  // Remove the button border
                        fontSize: '19px',
                        cursor: 'pointer'
                      }}
                    >
                      Create
                    </button>
                  </div>

                  <div className="btn btn2">
                    <a onClick={closeAddVoucherModal} style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}>Cancel</a>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Voucher;
